module.exports = __webpack_public_path__ + "static/media/empty-flag.c12af5e6.svg";